import React from 'react';
import { Skeleton } from '@mui/material';

// Placeholders com o mesmo formato do conteúdo final, para o layout não pular ao carregar.

export const TableSkeleton = ({ rows = 8 }) => (
    <div aria-busy="true" aria-label="Carregando dados do Censo">
        <Skeleton variant="rounded" height={31} sx={{ mb: 1 }} />
        {Array.from({ length: rows }, (_, index) => (
            <div key={index} style={{ display: 'flex', gap: 12, padding: '6px 0' }}>
                <Skeleton variant="text" sx={{ flex: 1 }} />
                <Skeleton variant="text" width={56} />
            </div>
        ))}
    </div>
);

export const PanelSkeleton = () => (
    <>
        <Skeleton variant="text" width="70%" height={32} />
        <Skeleton variant="text" width="40%" />
        <Skeleton variant="text" width="85%" sx={{ mb: 1 }} />
        <TableSkeleton rows={6} />
    </>
);

export const MapSkeleton = ({ withToolbar = true }) => (
    <div className="censo-dashboard" aria-busy="true" aria-label="Carregando mapa do Censo">
        {withToolbar && (
            <div className="censo-toolbar">
                <div className="censo-toolbar-group">
                    <Skeleton variant="text" width={110} />
                    <div className="censo-levels">
                        {[70, 72, 72, 150].map((width, index) => (
                            <Skeleton key={index} variant="rounded" width={width} height={31} />
                        ))}
                    </div>
                </div>
            </div>
        )}
        <div className="censo-body">
            <Skeleton variant="rounded" className="censo-map" sx={{ height: '75vh' }} />
            <section className="censo-map-data">
                <PanelSkeleton />
            </section>
        </div>
    </div>
);

export const CardsSkeleton = ({ count }) => (
    <div className="censo-panorama" aria-busy="true" aria-label="Carregando panorama do Censo">
        {Array.from({ length: count }, (_, index) => (
            <div key={index} className="censo-card">
                <Skeleton variant="text" width="60%" />
                <Skeleton variant="text" width="45%" height={34} />
            </div>
        ))}
    </div>
);
